import React from 'react'
import classNames from 'classnames'
import { AccountContextProvider } from '@/contexts/AccountContext'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { Footer } from '@/organisms/Footer'
import { SiteNav } from '@/organisms/SiteNav'
import { BaseLayout } from '../BaseLayout'

interface AccountLayoutProps {
  children: React.ReactNode
  isDarkMode: boolean
}

export const AccountLayout: React.FC<AccountLayoutProps> = ({ children, isDarkMode }) => {
  return (
    <BaseLayout isDarkMode={isDarkMode}>
      <AccountContextProvider>
        <SiteNav />
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <div
            className={classNames('min-h-screen', {
              'bg-black text-white': isDarkMode,
              'bg-core-gray-100 text-black': !isDarkMode,
            })}
          >
            {children}
          </div>
        </ErrorBoundary>
        <Footer />
      </AccountContextProvider>
    </BaseLayout>
  )
}
